import { InjectionToken } from '@angular/core';
import {
  WindowContainerContext,
  WindowContext
} from './window-context';

export const WINDOW_CONTEXT = new InjectionToken<WindowContext<any>>('@digitaix/core/window/WINDOW_CONTEXT');
export const WINDOW_CONTAINER_CONTEXT = new InjectionToken<WindowContainerContext<any>>('@digitaix/core/window/WINDOW_CONTAINER_CONTEXT');
